<!-- 
	This is the sign up page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
	<div>

		<!-- reset Up Form -->
		<a-card :bordered="false" class="my-50 card-signup header-solid h-full"
			:bodyStyle="{ paddingTop: 0 }">

			<template #title>
				
				<h5 class="font-web mt-10 font-semibold text-center">Reset Device</h5>
			</template>
			
			<div class="mb-10" v-if="statusRes !== ''">
				<div class="sign-up-gateways">
					<img style="width: 70px;height: 70px;border-radius: 2px;" class="logo-size"
						src="../../../public/images/MUIC_APP_512_02.png" alt="imag_confirmuseapp_1" />
				</div>
				<p class="text-center my-25 font-semibold text-muted"> IC-APP </p>
				<div v-if="statusRes === 'success'">
					<a-alert class="mt-10 mb-10" message="Success Tips" :description="textMsg" type="success" show-icon />
				</div>
				<div v-else>
					<a-alert message="Error" description="Your link cannot do this." type="error" show-icon />
				</div>
			</div>
			<div class="text-center" v-if="loadStatus">
				<a-spin class="mr-20" /> The system is checking and confirming your rights ...
			</div>
		</a-card>

		<div class="text-center">
			<p :style="{ fontSize: '10px' }" class="mt-0 mb-0 font-web font-weight-bold">
				พบปัญหาอื่นๆ สามารถติดต่อมายัง
			</p>
			<p :style="{ fontSize: '10px' }" class="mt-0 mb-0 font-web font-weight-bold">email
					&nbsp;&nbsp;&nbsp;&nbsp;<strong><a :style="{ fontSize: '12px' }"
						href="mailto:ic-inhouse@mahidol.edu">ic-inhouse@mahidol.edu</a></strong> </p>
		</div>
		<!-- / reset Up Form -->

	</div>
</template>

<script>

import MobileFrameVue from "./MobileFrame.vue";

export default ({
	components: {
		MobileFrameVue
	},
	data() {
		return {
			statusRes: '',
			loadStatus: false,
			textMsg: `Your ${this.$keycloak.fullName} identity has been successfully verified by the system. Please log in to access the application again`
		}
	},
	beforeCreate() {},
	computed: {
		getUrlPath() {
			return this.$route.query.token;
		},
	},
	mounted() {
		this.getTokenResetDevice()
	},
	methods: {
		async getTokenResetDevice() {

			this.loadStatus = true
			this.statusRes = ''
			try {
				const response = await this.$http.post(
					`ic-apps/fcm-device/${this.$route.query.token}/reset-app/`, {}
				);
				if (response.status === 200) {
					setTimeout(() => {
						this.statusRes = 'success'
						this.loadStatus = false
					}, 3000);
				} else {
					const error = new Error('Request Failed');
					error.response = response;
					throw error;
				}
			} catch (error) {
				setTimeout(() => {
					this.statusRes = 'error'
					this.loadStatus = false
				}, 3000);
			}

		}
	},
})

</script>

<style lang="scss"></style>